import { Box } from "@mui/material";
import "./style";
import Grid from "@mui/material/Grid2";
import {
  StyleBoxMain,
  StyledBoxWidth,
  StyledGrid,
  StyledGridContainer,
} from "./style";
import Logo from "../../../assets/images/nativeLogo.png";
import AuthImage from "../../../components/common/auth/AuthImage";
import ResetPassword from "../../../components/auth/reset-Password/ResetPassword";

const ResetPasswordPage = () => {
  return (
    <>
      <StyleBoxMain>
        <StyledBoxWidth>
          <StyledGridContainer container>
            <Grid size={{ md: 7, xs: 0 }}>
              <AuthImage />
            </Grid>

            <StyledGrid size={{ md: 5, xs: 12 }}>
              <Box>
                <img loading="lazy" src={Logo} alt="Login Visual" />
              </Box>
              <ResetPassword />
            </StyledGrid>
          </StyledGridContainer>
        </StyledBoxWidth>
      </StyleBoxMain>
    </>
  );
};

export default ResetPasswordPage;
